import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class WorkQueueTypeModel {
	period_name: string;
	id: number;
	name: string;
	color: string;
}

export function WorkQueueTypeModel_ClassTransform_Type() {
	return WorkQueueTypeModel;
}

export class WorkQueueModel {
	id: number;
	uid: number;
	name: string;
	color: string;
	purpose: WorkQueueTypes;
	@Transform(dateTransformer)
	created: Date;
	@Transform(dateTransformer)
	updated: Date;
	@Type(WorkQueueTypeModel_ClassTransform_Type)
	type: WorkQueueTypeModel;
}

export interface WorkQueueArgument {
	name: string;
	color: string;
}

export interface FocusQueueArgument {
	type_id: number;
}

export class WorkQueueDefaultResponse {
	success: boolean;
	error_messages?: string[];
}

export class WorkQueueFlagModel {
	queueId: number;
	name: string;
	color: string;
}

export type WorkQueueTypes = 'tracker' | 'focus';
